const StarIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0004 14.7917L4.85702 17.4958L5.83952 11.7683L1.67285 7.71251L7.42285 6.87918L9.99452 1.66834L12.5662 6.87918L18.3162 7.71251L14.1495 11.7683L15.132 17.4958L10.0004 14.7917Z'
        stroke='#B42318'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default StarIcon
